import { useDndMessageHandler } from '../../common/hooks/useDndMessageHandler';
import { IN_APP_HELP_COMPONENT } from 'navigation-components/config';

/**
 * Checks and sanitizes message events for the Help widget
 */
export const useHelpMessageHandler = callback => {
  useDndMessageHandler(callback, IN_APP_HELP_COMPONENT);
};